import React, { Component } from 'react';
import moment from 'moment';

import API from '@api';
import config from '@config';
import { getAppDownloadLink } from '@helpers';

const locationHost = window.location.host;
let isFreely = false;

if (locationHost.indexOf('freely') > -1) {
  isFreely = true;
}

class DetailPanel extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { program, display, channel } = this.props;
    return (
      <section
        className={`fv-detail-panel ${
          display ? 'fv-detail-panel--active' : ''
        }`}
      >
        {program && (
          <div className="fv-detail-panel__content">
            <span className="icon-close" onClick={this.props.closePanel} />
            {channel && (
              <img
                className="fv-detail-panel__channel"
                src={`${channel.images.default}?w=${config.channelImageWidth}`}
                alt=""
              />
            )}

            <div
              className="fv-detail-panel__header"
              style={
                program.image_url
                  ? {
                      backgroundImage: `url(${program.image_url}?w=${config.detailPanelImageWidth})`,
                    }
                  : {}
              }
            >
              <div className="fv-detail-panel__header__inner">
                <div className="fv-detail-panel__header__content">
                  <p className="fv-detail-panel__header__secondary-title">
                    {program.secondary_title}
                  </p>
                  <h3
                    dangerouslySetInnerHTML={{ __html: program.main_title }}
                  />
                  {program.start_time && (
                    <p className="fv-detail-panel__header__time-infos">
                      {moment(program.start_time).format('DD MMM YYYY - h:mma')}{' '}
                      -{' '}
                      {moment(program.start_time)
                        .add(moment.duration(program.duration))
                        .format('h:mma')}
                    </p>
                  )}
                  <div className="fv-detail-panel__header__links">
                    {program.player_links &&
                      program.player_links.tv &&
                      program.player_links.tv.program_url && (
                        <a
                          href={program.player_links.tv.program_url}
                          target="_blank"
                          className="watch-now"
                        >
                          {isFreely ? (
                            <img
                              src="/themes/custom/freely/img/play_btn.svg"
                              alt=""
                            />
                          ) : (
                            <img
                              src="/themes/custom/freeview/img/play_btn.svg"
                              alt=""
                            />
                          )}
                          <span>
                            <b>Watch now</b>
                          </span>
                        </a>
                      )}
                    {isFreely ? (
                      ''
                    ) : (
                      <a href={getAppDownloadLink()}>
                        <img
                          src="/themes/custom/freeview/img/fw_phone.svg"
                          alt=""
                        />
                        <span>
                          <b>Download our</b> Freeview mobile app
                        </span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="fv-detail-panel__block fv-detail-panel__summary">
              <h5>Summary</h5>
              <p>
                {program.synopsis &&
                  (program.synopsis.long ||
                    program.synopsis.medium ||
                    program.synopsis.short)}
              </p>
            </div>
            <div className="fv-detail-panel__ads">
              <h5>{drupalSettings.tvguide_sidebar_advertisement.title}</h5>
              <div
                dangerouslySetInnerHTML={{
                  __html: drupalSettings.tvguide_sidebar_advertisement.text,
                }}
              />
              <div
                dangerouslySetInnerHTML={{
                  __html: drupalSettings.tvguide_sidebar_advertisement.link,
                }}
              />
            </div>
          </div>
        )}
      </section>
    );
  }
}

export default DetailPanel;
